<template>
  <div class="my">
    <div class="user-bg">
      <img class="avatar" :src="$store.getters.user.avatar" alt="avatar" @click="$router.push('/my/avatar')">
    </div>
    <u-cell-group title="个人信息">
      <u-cell text="用户名" :value="$store.getters.user.username"></u-cell>
      <u-cell text="绑定邮箱" :value="$store.getters.user.email" show-arrow @click.native="$router.push('/my/bind-email')"></u-cell>
      <u-cell text="修改密码" show-arrow @click.native="$router.push('/my/reset-password')"></u-cell>
      <u-cell text="常用联系人" show-arrow @click.native="$router.push('/my/contacts')"></u-cell>
      <u-cell text="分类管理" show-arrow @click.native="$router.push('/my/tags')"></u-cell>
    </u-cell-group>
    <u-cell-group title="其它">
      <u-cell text="关于" show-arrow @click.native="$router.push('/about')"></u-cell>
    </u-cell-group>
    <u-button @click="logout" style="width:80%;margin: 40px 10% 20px;">退出</u-button>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import AV from 'leancloud-storage'
export default {
  methods: {
    ...mapActions({ storeLogout: 'logout' }),
    logout () {
      this.$confirm('确认要退出当前系统么？').then(() => {
        this.storeLogout()
        return AV.User.logOut().then(() => {
          this.$router.push('/auth')
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "../components/var.styl"
.user-bg
  position relative
  height 150px
  margin-bottom 60px
  background linear-gradient(to right top, lighten($color-primary,8%), darken($color-primary, 8%))
  box-shadow 0px 2px 7px 0px $color-primary
.avatar
  position absolute
  left 50%
  bottom 0
  width 80px
  height @width
  margin-bottom -40px
  margin-left -40px
  border-radius 50%
  /*animation avatar 3s infinite linear

@keyframes avatar
  0%
  100%
    border-top-left-radius 50%
    border-top-right-radius 65%
    border-bottom-left-radius 69%
    border-bottom-right-radius 50%
  50%
    border-top-left-radius 69%
    border-top-right-radius 50%
    border-bottom-left-radius 50%
    border-bottom-right-radius 65%*/
</style>



// WEBPACK FOOTER //
// My.vue?c80c34d2